const SYMBOL = { TRY: '₺', EUR: '€', USD: '$' };

/**
 * Para tutarini Turkce bicimde yazar: 28.400,00 ₺
 *
 * Neden ortak bir yardimci: AntD Statistic'in varsayilan bicimlendiricisi
 * Amerikan ayraclarini kullaniyor (28,400.00) ve ondalik basamak sayisini
 * gelen degerden aliyor. Backend bir alani ondalikli, digerini tam sayi
 * dondurdugunde ayni panoda "28,400.00 ₺" ile "836,125 ₺" yan yana
 * dusuyordu. Tutar gosteren her yer buradan gecmeli.
 *
 * Kurus HER ZAMAN yazilir; "836.125 ₺" ile "836.125,50 ₺" arasindaki farkin
 * yuvarlamadan mi geldigi belirsiz kalmasin.
 *
 * @param {number|string|null} amount
 * @param {string} currency  TRY | EUR | USD
 */
export const formatMoney = (amount, currency = 'TRY') =>
  `${Number(amount || 0).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  })} ${SYMBOL[currency] || currency}`;

/** Simge olmadan yalnizca sayi (simgeyi ayri basan bilesenler icin). */
export const formatAmount = (amount) =>
  Number(amount || 0).toLocaleString('tr-TR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export default formatMoney;
